import { render, staticRenderFns } from "./SkriningGiziLanjutPage.vue?vue&type=template&id=2b65a503&scoped=true&"
import script from "./SkriningGiziLanjutPage.vue?vue&type=script&lang=ts&"
export * from "./SkriningGiziLanjutPage.vue?vue&type=script&lang=ts&"
import style0 from "./SkriningGiziLanjutPage.vue?vue&type=style&index=0&id=2b65a503&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b65a503",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VChip,VCol,VDataTable,VIcon,VRow})
